import * as Yup from 'yup';

export const intersection = Yup.string()
  .trim()
  .max(100, 'Nearest main intersection should be less than 100 symbols')
  .required('Nearest main intersection is required');
